import { render, staticRenderFns } from "./BannerAds.vue?vue&type=template&id=ad401914&"
import script from "./BannerAds.vue?vue&type=script&lang=js&"
export * from "./BannerAds.vue?vue&type=script&lang=js&"
import style0 from "./BannerAds.vue?vue&type=style&index=0&id=ad401914&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports